import React from 'react';
import Header from './Header';

export const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Header con menú desplegable */}
      <Header />

      {/* Main Content */}
      <div className="flex-grow">
        {children}
      </div>
    </div>
  );
};

export default Layout;